import { mockPaymentPageData } from "./mockPaymentPageData";
import { mockSubmitPaymentResponse } from "./mockSubmitPaymentResponse";
import { createMockPollingPaymentResponse } from "./mockPollingPaymentResponse";
import { mockRequestAuthCodeResponse } from "./mockRequestAuthCodeResponse";
import { mockVerifyAuthCodeResponse } from "./mockVerifyAuthCodeResponse";
import { mockNewPaymentResponse } from "./mockNewPaymentResponse";
import { mockCancelPaymentResponse } from "./mockCancelPaymentResponse";
import { mockDeclineReceivedResponse } from "./mockDeclineReceivedResponse";
// import { paymentScreens } from "../PaymentScreenRouter/paymentScreens";

const useMockData = false;
const skipIntroScreen = false;
const forceScreen = false; // paymentScreens.managePaymentMethods;

// 🚨🚨🚨 👇 Don't change this 👇 🚨🚨🚨
const _useMockData_PROTECTED =
  process.env.NODE_ENV === "development" ? useMockData : false;
const _skipIntroScreen_PROTECTED =
  process.env.NODE_ENV === "development" ? skipIntroScreen : false;
const _forceScreen_PROTECTED =
  process.env.NODE_ENV === "development" ? forceScreen : null;
// 🚨🚨🚨 👆 Don't change this 👆 🚨🚨🚨

export const mockData = {
  shouldMock: _useMockData_PROTECTED,
  skipIntroScreen: _skipIntroScreen_PROTECTED,
  forceScreen: _forceScreen_PROTECTED,
  paymentPageData: mockPaymentPageData,
  submitPaymentResponse: mockSubmitPaymentResponse,
  createMockPollingPaymentResponse: createMockPollingPaymentResponse,
  requestAuthCodeResponse: mockRequestAuthCodeResponse,
  verifyAuthCodeResponse: mockVerifyAuthCodeResponse,
  newPaymentResponse: mockNewPaymentResponse,
  cancelPaymentResponse: mockCancelPaymentResponse,
  declineReceivedResponse: mockDeclineReceivedResponse,
};
